import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Link } from 'react-router-dom';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { Slider } from './Slider';
import { StorefrontListingCard } from './cards/StorefrontListingCard';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLIDER_HEIGHT = '326px';
export function SliderSection({
  title,
  cards,
  loading,
  seeMoreHref
}) {
  const scrollToTop = useScrollToTop();
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "1000",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      marginBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        children: title
      }), seeMoreHref && /*#__PURE__*/_jsx(Link, {
        to: seeMoreHref,
        onClick: scrollToTop,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.sliderSection.seeMore"
        })
      })]
    }), loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      blockSize: SLIDER_HEIGHT,
      grow: true
    }) : /*#__PURE__*/_jsx(Slider, {
      children: cards.map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
        card: card
      }, index))
    })]
  });
}

// TODO: remove this if BE starts returning the translated titles
export function translateSectionTitle(sectionType) {
  switch (sectionType) {
    case 'INSTALL_HISTORY':
      return unescapedText('marketplaceStorefront.suggestionSection.installHistory');
    case 'INSTALLED_WITH':
      return unescapedText('marketplaceStorefront.suggestionSection.installedWith');
    case 'MOST_INSTALLED':
      return unescapedText('marketplaceStorefront.suggestionSection.mostInstalled');
    case 'NEWEST':
      return unescapedText('marketplaceStorefront.suggestionSection.newest');
    case 'SIMILAR_PORTALS':
      return unescapedText('marketplaceStorefront.suggestionSection.similarPortals');
    case 'TECH_STACK':
      return unescapedText('marketplaceStorefront.suggestionSection.techStack');
    case 'TRENDING':
      return unescapedText('marketplaceStorefront.suggestionSection.trending');
    case 'USE_CASE':
      return unescapedText('marketplaceStorefront.suggestionSection.useCase');
    case 'VIEW_AND_INSTALLS':
      return unescapedText('marketplaceStorefront.suggestionSection.viewAndInstalls');
    default:
      return String(sectionType);
  }
}